import CityData from './city-data.json';
import BusinessNature from './business-nature.json';
import BusinessNatureAB from './business-nature-agency-banking.json';

const provinceKeys = Object.keys(CityData);

// 省份数据
export const provinceData = provinceKeys.map(item => {
    return {
      value: item,
      label: CityData[item].label,
    }
  });

// 城市数据
export const cityData = provinceKeys.reduce((acc, item) => {
  const citys = CityData[item].citys;
  acc[item] = Object.keys(citys)
    .map(city => {
      const targetCity = citys[city];
      return {
        value: city,
        label: targetCity.city,
      }
    })

  return acc;
}, {});

// businessNature数据
export const businessNatureData = Object.keys(BusinessNature)
  .map(item => {
    const { label } = BusinessNature[item];

    return {
      value: item,
      label,
    }
  });

// businessDescription数据
export const businessDescriptionData = BusinessNature;

/**
 * 合并agencyBanking数据
 * @param  {[type]} businessData   [description]
 * @param  {[type]} businessDataAB [description]
 * @return {[type]}                [description]
 */
const mergeBusinessData = (businessData, businessDataAB) => {
  const result = Object.keys(businessData)
    .reduce((acc, item) => {
      const { label, services } = businessData[item];
      const lastService = services.slice(-1);
      const agencyBankingData = businessDataAB[item];

      if (agencyBankingData) {
        // 存在other选项
        if (lastService[0].value === '1001') {
          acc[item] = {
            label,
            services: [...services.slice(0, -1), ...agencyBankingData.services, ...lastService],
          }
        } else {
          acc[item] = {
            label,
            services: [...services, ...agencyBankingData.services],
          }
        }
      } else {
        acc[item] = businessData[item];
      }

      return acc;
    }, {});

  return Object.assign(businessDataAB, result);
};

const agencyBankingData = mergeBusinessData(BusinessNature, BusinessNatureAB);

// businessNature数据(agencyBanking)
export const businessNatureABData = Object.keys(agencyBankingData)
  .map(item => {
    const { label } = agencyBankingData[item];

    return {
      value: item,
      label,
    }
  });

// businessDescription数据(agencyBanking)
export const businessDescriptionABData = agencyBankingData;

const dataProcessing = (data, processNo) => {
  console.log(processNo, "processNo")
  let onlineStoreArr = [
    {
      type: "title",
      name: "",
      value: "Online Store Details",
    },
  ];
  data.businessOnlineStore.onlineStoreList.filter((item) => {
    onlineStoreArr.push(
      {
        type: "nomal",
        name: "Marketplace or Social Media",
        value: item.socialMedia,
      },
      {
        type: "wrap",
        name: "Profile Name or URL",
        value: item.url,
      }
    );
  });
  let all = {
    dataA: "",
    dataB: "",
    dataC: "",
    dataD: "",
    dataE: "",
  }
  if (processNo == "1") {
    all.dataB = {
      left: [
        {
          type: "title",
          name: "",
          value: "Digital Payment Solutions",
        },
        {
          type: "nomal",
          name: "Full Name",
          value:
            data.personalInfo.firstName +
            data.personalInfo.middleName +
            data.personalInfo.lastName,
        },
        {
          type: "nomal",
          name: "Mobile Number",
          value: data.personalInfo.mobile,
        },
        {
          type: "nomal",
          name: "Email Address",
          value: data.personalInfo.email,
        },
      ],
      middle: [
        {
          type: "title",
          name: "",
          value: "Home Address",
        },
        {
          type: "nomal",
          name: "Home Address",
          value:
            data.homeAddress.streetAddress +
            data.homeAddress.subdivision +
            data.homeAddress.barangay +
            data.homeAddress.city +
            data.homeAddress.province +
            data.homeAddress.zipCode,
        },
      ],
      right: [
        {
          type: "title",
          name: "",
          value: "Additional Details",
        },
        {
          type: "nomal",
          name: "Date of Birth",
          value:
            data.additionalDetails.month +
            data.additionalDetails.day +
            data.additionalDetails.year,
        },
        {
          type: "nomal",
          name: "Country of Birth",
          value: data.additionalDetails.countryOfBirth,
        },
        {
          type: "nomal",
          name: "City of Birth",
          value: data.additionalDetails.cityOfBirth,
        },
        {
          type: "nomal",
          name: "Citizenship",
          value: data.additionalDetails.citizenship,
        },
        {
          type: "nomal",
          name: "TIN",
          value: data.additionalDetails.tin,
        },
      ],
    }
    all.dataE = {
      selfie: {
        title: "Selfie with ID",
        name: "Selfie with ID",
        imgurl: data.selfieWithIDPhoto.idCardiUrl,
      },
      exterior: {
        title: "Store Photo",
        name: "Exterior",
        imgurl: data.storePhoto.exterior[0],
      },
      interior: {
        title: "",
        name: "Interior",
        imgurl: data.storePhoto.interior[0],
      },
    }
  } else if (processNo == 2) {
    all.dataB = {
      left: [
        {
          type: "title",
          name: "",
          value: "Digital Payment Solutions",
        },
        {
          type: "nomal",
          name: "Full Name",
          value:
            data.personalInfo.firstName +
            data.personalInfo.middleName +
            data.personalInfo.lastName,
        },
        {
          type: "nomal",
          name: "Mobile Number",
          value: data.personalInfo.mobile,
        },
        {
          type: "nomal",
          name: "Email Address",
          value: data.personalInfo.email,
        },
      ],
      middle: [
        {
          type: "title",
          name: "",
          value: "",
        },
        {
          type: "nomal",
          name: "Email Address",
          value: data.personalInfo.email,
        },
      ],
      right: [],
    }
    all.dataE = {
      selfie: {
        title: "Selfie with ID",
        name: "Selfie with ID",
        imgurl: data.selfieWithIDPhoto.idCardiUrl || "",
      },
      certificate: {
        title: "DTI Certificate",
        name: "Photo of DTI Certificate",
        imgurl: data.dtiPhoto && data.dtiPhoto.dtiUrl || "",
      },
      exterior: {
        title: "Store Photo",
        name: "Exterior",
        imgurl: data.storePhoto.exterior[0],
      },
      interior: {
        title: "",
        name: "Interior",
        imgurl: data.storePhoto.interior[0],
      },
    }
  } else if (processNo == 3) {
    all.dataB = {
      left: [
        {
          type: "title",
          name: "",
          value: "Digital Payment Solutions",
        },
        {
          type: "nomal",
          name: "Full Name",
          value:
            data.personalInfo.firstName +
            data.personalInfo.middleName +
            data.personalInfo.lastName,
        },
        {
          type: "nomal",
          name: "Mobile Number",
          value: data.personalInfo.mobile,
        },
        {
          type: "nomal",
          name: "Email Address",
          value: data.personalInfo.email,
        },
      ],
      middle: [
        {
          type: "title",
          name: "",
          value: "Home Address",
        },
        {
          type: "nomal",
          name: "Home Address",
          value:
            data.homeAddress.streetAddress +
            data.homeAddress.subdivision +
            data.homeAddress.barangay +
            data.homeAddress.city +
            data.homeAddress.province +
            data.homeAddress.zipCode,
        },
      ],
      right: [
        {
          type: "title",
          name: "",
          value: "Additional Details",
        },
        {
          type: "nomal",
          name: "Date of Birth",
          value:
            data.additionalDetails.month +
            data.additionalDetails.day +
            data.additionalDetails.year,
        },
        {
          type: "nomal",
          name: "Country of Birth",
          value: data.additionalDetails.countryOfBirth,
        },
        {
          type: "nomal",
          name: "City of Birth",
          value: data.additionalDetails.cityOfBirth,
        },
        {
          type: "nomal",
          name: "Citizenship",
          value: data.additionalDetails.citizenship,
        },
        {
          type: "nomal",
          name: "TIN",
          value: data.additionalDetails.tin,
        },
      ],
    }
    all.dataE = {
      selfie: {
        title: "Selfie with ID",
        name: "Selfie with ID",
        imgurl: data.selfieWithIDPhoto.idCardiUrl || "",
      },
      certificate: {
        title: "SEC Certificate",
        name: "Photo of SEC Certificate",
        imgurl: data.secPhoto && data.secPhoto.secUrl || "",
      },
      exterior: {
        title: "Store Photo",
        name: "Exterior",
        imgurl: data.storePhoto.exterior[0],
      },
      interior: {
        title: "",
        name: "Interior",
        imgurl: data.storePhoto.interior[0],
      },
    }
  }
  all.dataA = {
    left: [
      {
        type: "title",
        name: "",
        value: "Digital Payment Solutions",
      },
      {
        type: "nomal",
        name: "Payment Links",
        value:
          data.digitalPayment.digitalPaymentList[0].chooseFlag == 1
            ? "Yes"
            : "No",
      },
      {
        type: "nomal",
        name: "Email Billing",
        value:
          data.digitalPayment.digitalPaymentList[1].chooseFlag == 1
            ? "Yes"
            : "No",
      },
      {
        type: "nomal",
        name: "Website Plugin",
        value:
          data.digitalPayment.digitalPaymentList[2].chooseFlag == 1
            ? "Yes"
            : "No",
      },
      {
        type: "nomal",
        name: "Checkout App",
        value:
          data.digitalPayment.digitalPaymentList[3].chooseFlag == 1
            ? "Yes"
            : "No",
      },
    ],
    middle: [
      {
        type: "title",
        name: "",
        value: "Physical Payment Solutions",
      },
      {
        type: "nomal",
        name: "Point-of-Sale Terminals",
        value: "",
      },
      {
        type: "nomal",
        name: "In-store POS",
        value:
          data.physicalPayment.physicalPaymentList[0].chooseFlag == 1
            ? "Yes"
            : "No",
      },
      {
        type: "nomal",
        name: "Mobile POS",
        value:
          data.physicalPayment.physicalPaymentList[1].chooseFlag == 1
            ? "Yes"
            : "No",
      },
      {
        type: "nomal",
        name: "miniPOS",
        value:
          data.physicalPayment.physicalPaymentList[2].chooseFlag == 1
            ? "Yes"
            : "No",
      },
    ],
    right: [],
  }
  all.dataC = {
    left: [
      {
        type: "title",
        name: "",
        value: "Business Details",
      },
      {
        type: "nomal",
        name: "Type of Merchant",
        value: data.businessDetails.processNo,
      },
      {
        type: "nomal",
        name: "Signed Documents",
        value: "Merchant Agreement Data Privacy",
      },
      {
        type: "nomal",
        name: "Business Name",
        value: data.businessDetails.businessName,
      },
      {
        type: "wrap",
        name: "Business Description",
        value: data.businessDetails.businessDescription,
      },
    ],
    middle: [
      {
        type: "title",
        name: "",
        value: "Business Address",
      },
      {
        type: "nomal",
        name: "Business Address",
        value:
          data.businessAddress.subdivision +
          data.businessAddress.streetAddress +
          data.businessAddress.barangay +
          data.businessAddress.city +
          data.businessAddress.province +
          data.businessAddress.zipCode,
      },
    ],
    right: onlineStoreArr,
  }
  all.dataD = [
    {
      type: "title",
      name: "",
      value: "Settlement Account",
    },
    {
      type: "nomal",
      name: "Bank",
      value: data.settlementAccount.bankType,
    },
    {
      type: "nomal",
      name: "Account Name",
      value: data.settlementAccount.accountName,
    },
    {
      type: "nomal",
      name: "Account Number",
      value: data.settlementAccount.accountNumber,
    },
  ]


  console.log(data, "data")
  return all
}
export const doProcessing = dataProcessing